import {TEMPLATE_REGEX, TEMPLATE_EXPRESSION_REGEX, TEMPLATE_CALC_REGEX} from '../values/template';

export const getDependenciesFromTemplate = (template: string): string[] => {
  const dependencies = new Set<string>();

  template.replace(TEMPLATE_REGEX, (_, expression) => {
    const {func, arg} = TEMPLATE_EXPRESSION_REGEX.exec(expression)?.groups ?? {arg: expression, func: undefined};
    switch (func) {
      case 'calc': {
        const {left, right = ''} = TEMPLATE_CALC_REGEX.exec(arg)?.groups ?? {
          left: arg,
          operator: undefined,
          right: undefined,
        };

        if (left && !left.match(/^\d+$/)) dependencies.add(left.split(':')[0]);
        if (right && !right.match(/^\d+$/)) dependencies.add(right.split(':')[0]);

        break;
      }
      case 'date':
      case 'lower':
      case 'percentage': {
        dependencies.add(arg.split(':')[0]);
        break;
      }
      default: {
        dependencies.add(expression.split(':')[0]);
      }
    }
    return '';
  });

  return [...dependencies];
};
